import * as React from 'react';
import numeral from 'numeral';
import makeComp from '../util/profiler';
import * as S from './StoragePercentageBilling.styles';

interface StoragePercentageBillingProps {
  storageAvailable: number;
  storageUsed: number;
  artifactsAvailable: number;
  artifactsUsed: number;
}

const StoragePercentageBilling: React.FC<StoragePercentageBillingProps> = makeComp(
  ({storageAvailable, storageUsed, artifactsAvailable, artifactsUsed}) => {
    const storagePercent = Math.min(storageUsed / storageAvailable, 1);
    const storageOver = Math.max(storagePercent - 1, 0);

    const artifactsPercent = Math.min(artifactsUsed / artifactsAvailable, 1);
    const artifactsOver = Math.max(artifactsPercent - 1, 0);

    const formatStoragePercentage = (num: number) => {
      return numeral(num).format('0.0b');
    };

    return (
      <S.StorageUsageCard>
        <S.StorageUsageRow>
          <S.StorageUsageType>Storage</S.StorageUsageType>
          <S.StorageUsageValue>
            <S.UsedValue over={storageOver > 0}>
              {formatStoragePercentage(storageUsed)}
            </S.UsedValue>{' '}
            / {formatStoragePercentage(storageAvailable)}
          </S.StorageUsageValue>
          <S.StorageUsageBar>
            <div
              className="progress"
              style={{
                width: '100%',
                height: 18,
                background: '#d2d2d2',
                borderRadius: 12,
                position: 'relative',
              }}>
              <span
                className="used"
                style={{
                  display: 'inline-block',
                  width: storagePercent * 100 + '%',
                  height: '100%',
                  background: storageOver > 0 ? '#ff5447' : '#aaa',
                  borderRadius: 12,
                }}></span>
            </div>
          </S.StorageUsageBar>
        </S.StorageUsageRow>
        <S.StorageUsageRow>
          <S.StorageUsageType>Artifacts</S.StorageUsageType>
          <S.StorageUsageValue>
            <S.UsedValue over={artifactsOver > 0}>
              {formatStoragePercentage(artifactsUsed)}
            </S.UsedValue>{' '}
            / {formatStoragePercentage(artifactsAvailable)}
          </S.StorageUsageValue>
          <S.StorageUsageBar>
            <div
              className="progress"
              style={{
                width: '100%',
                height: 18,
                background: '#d2d2d2',
                borderRadius: 12,
                position: 'relative',
              }}>
              <span
                className="used"
                style={{
                  display: 'inline-block',
                  width: artifactsPercent * 100 + '%',
                  height: '100%',
                  background: artifactsOver > 0 ? '#ff5447' : '#aaa',
                  borderRadius: 12,
                }}></span>
            </div>
          </S.StorageUsageBar>
        </S.StorageUsageRow>
      </S.StorageUsageCard>
    );
  },
  {id: 'StoragePercentage', memo: true}
);

export default StoragePercentageBilling;
